import React from "react";
import Header from "../../layouts/AuthLayout/header/header";
import { Link } from "react-router-dom";
import CartPage from "../../features/cart/cart-page";

export default function Cart() {
  return <CartPage />;
}
